/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
import { TopTaskType } from '../enums/top-task-type';
export class TopTaskEntity extends Entity {
  candidateId: string | null = null;
  createdAt: string | null = null;
  id: string = '';
  opportunityId: string | null = null;
  ownerId: string | null = null;
  positionId: string | null = null;
  snoozedAt: string | null = null;
  taskExpectedCompletionDateTime: string | null = null;
  taskExpectedStartDateTime: string | null = null;
  topTaskType: TopTaskType | null = null;
  candidateCalculatedDisplayName?: string | null = null;
  opportunityJobName?: string | null = null;
  reputationDetailsId?: string | null = null;
  static override key = 'TopTask';
  static override schema = {};
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'TopTask' in input
    ) {
      const { TopTask: wrapped, ...rest } = input as {
        TopTask: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}